var styles = {"box":"ProfilePanel_box_137aq_5","row":"ProfilePanel_row_137aq_9","no-padding-top":"ProfilePanel_no-padding-top_137aq_17","list":"ProfilePanel_list_137aq_21","title":"ProfilePanel_title_137aq_34","description":"ProfilePanel_description_137aq_55"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
